export const HM_TOPBAR_CHAT_TOGGLE = "HM_TOPBAR_CHAT_TOGGLE";
export const HM_TOPBAR_OPEN_MOBILE_NAVIGATION = 'HM_TOPBAR_OPEN_MOBILE_NAVIGATION';
